import { Component } from '@angular/core';
import { CommentViewer } from '../comment-menu.component';

@Component({
	selector: 'comment-viewers-overlay',
	templateUrl: './comment-viewers.component.html',
	styleUrls: ['./comment-viewers.component.scss']
})
export class ViewersOverlayComponent {
	public viewers: CommentViewer[] = [];
	public viewersLoading: boolean = false;
}
